import { useTranslation } from "react-i18next";
import SectionHeader from "../Common/SectionHeader";

const HelpHeader = () => {
    const { t } = useTranslation();
    return (
        <SectionHeader
            title={t("HELP_HEADER_TITLE")}
            subtitle={t("HELP_HEADER_SUBTITLE")}
            className="md:items-start md:justify-between"
        />
    );
};

export default HelpHeader;
